// extracted by mini-css-extract-plugin
export default {"main":"NodeMenu_main__c1xlW","menu":"NodeMenu_menu__O5Ykk","header":"NodeMenu_header__A4zkP","divider":"NodeMenu_divider__+z9Kq"};